<template>
  <v-tooltip
    v-if="tooltip.length > 0"
    bottom
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        class="mx-1"
        :style="`width: ${size}px !important; height: ${size}px !important;`"
        :loading="loading"
        :color="color"
        :disabled="disabled"
        :dark="dark && ((disabled && $vuetify.theme.isDark === 'dark') || !disabled)"
        :light="light && ((disabled && $vuetify.theme.isDark === 'light') || !disabled)"
        :text="text"
        :outlined="outlined"
        @click="$emit('click')"
      >
        <slot></slot>
      </v-btn>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>

  <v-btn
    v-else
    class="mx-1"
    :style="`width: ${size}px !important; height: ${size}px !important;`"
    :loading="loading"
    :color="color"
    :disabled="disabled"
    :dark="dark && ((disabled && $vuetify.theme.isDark === 'dark') || !disabled)"
    :light="light && ((disabled && $vuetify.theme.isDark === 'light') || !disabled)"
    :text="text"
    :outlined="outlined"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </v-btn>
</template>
<script>
import Loader from "@/components/Loader.vue";
export default {
  name: "SlotChip",

  components: {
    Loader
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    color: {
      type: String,
      default: 'primary',
    },

    tooltip: {
      type: String,
      default: '',
    },

    size: {
      type: Number,
      default: 36,
    },

    dark: {
      type: Boolean,
      default: true,
    },

    light: {
      type: Boolean,
      default: false,
    },

    text: {
      type: Boolean,
      default: false,
    },

    outlined: {
      type: Boolean,
      default: false,
    },
  }
}
</script>
<style scoped>
  button {
    min-width: 0 !important;
    min-height: 0 !important;
    padding: 0 !important;
    cursor: pointer;
  }
</style>
